import {
  numberDigits,
  engineDigit,
  phoneDigits
} from './modules/validations';

$(document).ready(function () {
  let engine = document.querySelector('.engine-input');

  numberDigits();
  phoneDigits();
  engineDigit(engine);
});


// WEBPACK FOOTER //
// ./app/webpacker/src/js/numeric_validations.js